import React from "react";
import { PatientMedicationProfileWithDetails } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppCard, AppCardHeader, AppCardTitle, AppCardContent } from "./Generic/AppCard";
import { AppList, AppListItem } from "./Generic/AppList";

interface Props {
  medications: PatientMedicationProfileWithDetails[];
}

export const PatientMedicationsCard = (props: Props) => {
  return (
    <AppCard>
      <AppCardHeader>
        <AppCardTitle>{translate(STRINGS.MEDICATIONS)}</AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        <AppList>
          {props.medications.map((medication, index) => (
            <AppListItem
              key={index}
              bulletNumber={index + 1}
              title={medication.medicationName}
              extra={medication.dose}
            />
          ))}
        </AppList>
      </AppCardContent>
    </AppCard>
  );
};
